import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
interface LoginInput {
    phone: string;
    password: string;
    language: string;
    country_code: string;
    otp?: string;
  }
  interface OTPInput{
    phone_number: string;
    from_register: number;
    country_code: string;
  }
  export const getLoginUser = (
    input: LoginInput,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
  ) => {
    axios
      .post(`${global.api_url}/api/login`, input)
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
          
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      })
  };
  export const getOTP = (
    input: OTPInput,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
  ) => {
      axios.post(`${global.api_url}/api/generate_otp`, input)
      .then((response: AxiosResponse) => {
        if (response.status === 200){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
        }

  export const getRoleFeatures = (
  _successCallBack?: (response: any) => void,
  _errorCallBack?: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  console.log("User details from storage:", userDetailsFromStorage);
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
  };
  axios
    .get(`${global.api_url}/api/my_features`, { headers})
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        try {
          const features = response.data?.message?.features;
          const company = response.data?.message?.company;
          if (features) {
            localStorage.setItem('roleFeatures', JSON.stringify(features));
          }
          if (company) {
            localStorage.setItem('companyDetails', JSON.stringify(company));
          }
        } catch (e) {
          console.warn('Could not store role features', e);
        }

        _successCallBack?.(response.data);
      } else {
        _errorCallBack?.(`Unexpected status code: ${response.status}`);
      }
    })
    .catch((error: AxiosError<any>) => {
      console.log("Error caught:", error);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 || status === 404) {
          _errorCallBack?.(data);
        } else if (status === 401) {
          localStorage.clear();
        } else {
          _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
        }
      } else {
        _errorCallBack?.("Network or server error");
        console.log(error)
      }
    });
};